import React from 'react'
import styled from 'styled-components'
import media, { RadioWrapper, RheostatSlider } from '../../../utils/style'
import { rem } from 'polished'
import { Box } from 'rebass'
import { Text } from 'rebass'

const TabWrapper = styled(Box)`
  width: 100%;
  max-width: ${(props) => props.theme.content.max.width};
  position: relative;
  z-index: 1;
  background-color: ${(props) => props.theme.colors.white};
  text-align: center;
  ${media.LargeScreenUp`
  overflow: visible;
  &::before {
    content:'';
    position: absolute;
    z-index: -1;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    box-shadow:
      0 30px 30px 0px rgba(66,76,94,0.03),
      0 25px 25px 0 rgba(0,0,0,0.01);
  }
  `};
  label {
    text-transform: none;
    font-weight: ${(props) => props.theme.weights[0]};
    font-size: medium;
    color: ${(props) => props.theme.colors.grey_op80};
    line-height: 2.45;
  }
  input[type='radio']:checked + label {
    font-weight: ${(props) => props.theme.weights[1]};
  }
  fieldset {
    text-align: left;
  }
  .react-tabs__tab-list {
    width: 100%;
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .react-tabs__tab {
    color: ${(props) => props.theme.colors.grey_light_op65};
    font-size: ${(props) => rem(props.theme.fontSizes[2])};
    line-height: 1.6;
    cursor: pointer;
    display: inline-block;
    flex: 1 1 auto;
    margin: 0;
    padding: ${rem(13)} ${rem(10)} ${rem(17)};
    ${media.LargeScreenUp`
    padding: ${rem(13)} ${rem(10)};
    `};
    background-color: ${(props) => props.theme.colors.grey_light_op30};
    transition: background-color 0.8s
        ${(props) => props.theme.ease.ease_out_circ},
      color 0.8s ${(props) => props.theme.ease.ease_out_expo};
    a {
      display: block;
      text-transform: none;
      color: ${(props) => props.theme.colors.grey_light_op65};
      ${media.LargeScreenUp`
      display: inline;
      `};
    }

    &:hover {
      background-color: ${(props) => props.theme.colors.grey_op10};
    }

    &:hover,
    &:hover a {
      color: ${(props) => props.theme.colors.grey_light};
    }
  }

  .react-tabs__tab--selected {
    color: ${(props) => props.theme.colors.grey_light};
    background: ${(props) => props.theme.colors.white};
    a,
    &:hover a {
      color: ${(props) => props.theme.colors.blue};
    }
    &:hover {
      background: ${(props) => props.theme.colors.white};
    }
  }

  .rheostat-progress {
    background-color: ${(props) => props.theme.colors.green};
    border-radius: 3px;
    height: 8px;
  }

  .rheostat-background {
    border-radius: 3px;
    height: 8px;
  }

  .rheostat-handle {
    border: 1px solid ${(props) => props.theme.colors.grey_op75};
  }
`

const Header = styled(Box)`
  width: 100%;
`

const TabLabel = styled(Text)`
  display: inline-block;
  text-transform: uppercase;
  font-weight: ${(props) => props.theme.weights[1]};
`

const TabPanelFooter = styled(Box)`
  position: relative;
  text-align: center;
  color: ${(props) => props.theme.colors.grey_light};
  &::after {
    content: '';
    position: absolute;
    height: 1px;
    top: 0;
    left: -1.5%;
    width: 103%;
    background-color: ${(props) => props.theme.colors.grey_light_op30};
  }
`

const InlineRadioWrapper = styled(RadioWrapper)`
  display: inline-block;
  width: 100%;
  ${media.MediumScreenUp`
  width: 50%;
  `};
  ${media.LargeScreenUp`
  width: 33%;
  `};
`

const Legend = styled.legend`
  display: block;
  text-transform: uppercase;
  text-align: left;
  color: ${(props) => props.theme.colors.grey_op80} !important;
  font-size: ${(props) => rem(props.theme.fontSizes[2])} !important;
  letter-spacing: ${rem(0.9)};
  line-height: 1.5;
  margin: 45px 0 15px 10px;
  a {
    white-space: nowrap;
    color: ${(props) => props.theme.colors.blue};
    [disabled] & {
      color: ${(props) => props.theme.colors.grey_light} !important;
    }
  }
  [disabled] & {
    color: ${(props) => props.theme.colors.grey_light} !important;
    pointer-events: none;
  }
`

const StaticLabel = styled(({ pointer, match, ...rest }) => <Text {...rest} />)`
  color: ${(props) => props.theme.colors.blue};
  cursor: ${(props) => (props.pointer ? 'pointer' : 'initial')};
  font-size: ${(props) => rem(props.theme.fontSizes[4])};
  font-weight: ${(props) =>
    props.pointer && props.match
      ? props.theme.weights[1]
      : props.theme.weights[0]};
  transition: color 1.8s ${(props) => props.theme.ease.ease_out_expo};
  &:hover {
    color: ${(props) =>
      props.pointer ? props.theme.colors.blue : props.theme.colors.grey_light};
  }
`

const RheostatSliderWithDragValue = styled(RheostatSlider)`
  .rheostat-handle {
    &::after {
      content: '${(props) => props.slidervalue}';
      color: ${(props) =>
        !props.disabled
          ? props.theme.colors.blue
          : props.theme.colors.grey_light};
      font-size: ${(props) => rem(props.theme.fontSizes[4])};
      font-weight: ${(props) => props.theme.weights[1]};
      position: absolute;
      top: ${rem(-15)};
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: transparent;
    }
  }
`

export {
  TabWrapper,
  TabLabel,
  StaticLabel,
  Legend,
  InlineRadioWrapper,
  TabPanelFooter,
  RheostatSliderWithDragValue,
  Header
}
